import React from 'react'
import { useField } from 'formik'
import { Field, Form, FormSaveButton } from '@ztechapps/webui.form'
import { CustomerSelectCreatable } from '@ztechapps/customer.webui'
import { Stack } from 'react-bootstrap'
import type { PartialDeep } from 'type-fest'
import type { Customer } from '@ztechapps/common.contract'
import { isValidEmail } from '@ztechapps/common.utils'
import type { SelectCreatableOption } from '@ztechapps/webui.input'
import { useUpdateOrCreateOrderCustomer } from '../../view/sales/item/hooks/useUpdateOrCreateOrderCustomer'
import { routesDef } from '../../config/routes'

export const AddNewFromCustomerForm = ({ onSuccessSubmit }: { onSuccessSubmit?: (value: string) => void }) => {
  const { onChangeCustomer } = useUpdateOrCreateOrderCustomer()

  const initialValues = {
    by: null,
  }

  const validate = (values) => {
    const errors: any = {}
    if (!values.by?._id) {
      errors.by = 'Required'
    }

    if (values.by?.__isCreate) {
      if (!values.by?.profile?.email) {
        errors.by = 'Required'
      } else if (!isValidEmail(values.by?.profile?.email)) {
        errors.by = 'Need a valid email when creating new customer.'
      }
    }

    return errors
  }

  const onSubmit = async ({
    by,
  }: {
    by: PartialDeep<Customer> & SelectCreatableOption & { company: SelectCreatableOption }
  }) => {
    const order = await onChangeCustomer({ by })
    const route = routesDef.OrderItemPage.altPath({
      _id: order?._id,
    })
    onSuccessSubmit?.(route)
  }

  return (
    <Form onSubmit={onSubmit} initialValues={initialValues} validate={validate}>
      <FormLayout />
      <div className={'d-flex justify-content-end mt-3'}>
        <FormSaveButton text="Create" />
      </div>
    </Form>
  )
}

const FormLayout = () => {
  const [, { value }] = useField('by')

  return (
    <Stack gap={2}>
      <Field
        name="by"
        component={CustomerSelectCreatable}
        label="Customer"
        help="Select the new customer for this order."
        onChange
        showInfo={!value?.__isCreate}
        labelKey={value?.__isCreate ? 'profile.email' : 'profile.name'}
        autoFocus
      />
    </Stack>
  )
}
